<template>
  <div style="min-height: 92vh">
    <h3>Meseros de restaurante</h3>
    <uv-data-table :config="config" :data="meseros" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <MeserosForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </MeserosForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import MeserosForm from "../Meseros/MeserosForm";

export default {
  name: "MeserosCRUD",
  components: {
    modal,
    uvDataTable,
    MeserosForm,
  },
  props: [],
  data() {
    return {
      formIndex: 0,
      formHeight: 0,
      editMode: false,
      meseros: [],
      editData: {},
      departamentos: [],
      showModal: false,
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar Mesero",
            icon: "lni lni-plus",
            buttonId: "addMesero",
            require: false,
          },
          {
            text: "Editar Mesero",
            icon: "lni lni-pencil-alt",
            buttonId: "editMesero",
            require: true,
          },
          {
            text: "Eliminar Mesero",
            icon: "lni lni-trash",
            buttonId: "eliminarMesero",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            title: "Departamentos",
            dataName: "Nombre",
            text: "Departamentos",
            value: "DepartamentoText",
            canBeFiltered: true,
          },
          {
            text: "Numero mesero",
            value: "NEmp",
          },
          {
            title: "Estatus",
            dataName: "Activo",
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              return row.Activo
                ? '<span class="green--text">Activo</span>'
                : '<span class="red--text">Inactivo</span>';
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMesero") {
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Mesero");
        this.showModal = true;
      } else if (buttonId == "editMesero") {
        const cashier = this.$pgsHelper.getById(
          this.meseros,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$pgsHelper.log(this.editData);
        this.$refs.modalForm.setTitle(`Editar Mesero`);
        this.showModal = true;
      } else if (buttonId == "eliminarMesero") {
        this.deleteMesero(idSelected[0]);
      }
    },
    optButtonClick() { },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.addMesero(data);
      } else if (doAction == "EDIT") {
        this.editMesero(data);
      }
    },
    deleteMesero(Id) {
      const deletedObject = this.$pgsHelper.getById(this.meseros, "id", Id) || { Id };
      let datos = { Id }; //localStorage.getItem("selectedDepartment");
      this.$swal({
        title: "¿Deseas eliminar este mesero?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Meseros-deleteMesero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "MESERO_DELETE",
              Mensaje: `Mesero eliminado: ${Id}`,
              reference: { id: Id, tp: "SEC-Mesero", al: "MESERO" },
              data: deletedObject
            });
            this.getMeserosAB();
            this.$swal(
              "Mesero eliminado",
              "El mesero se eliminó correctamente",
              "success"
            );
          } else {
            this.$swal(
              "Error deleting mesero",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos"
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
    addMesero(datos) {
      this.$swal({
        title: "¿Deseas guardar la información del mesero?",
        text: "El mesero se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Meseros-createMesero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const targetId = result.value.data.id || (result.value.data.data && result.value.data.data.id) || datos.Id;
            const meseroName = datos.Nombre || "MESERO";
            this.$pgsHelper.writeLog({
              Evento: "MESERO_CREATE",
              Mensaje: `Mesero creado: ${meseroName}`.trim(),
              reference: { id: targetId, tp: "SEC-Mesero", al: meseroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El Mesero se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.getMeserosAB();
              this.toggleModal(false);
            });
          } else {
            this.$swal("Error saving Mesero", result.value.data.error, "error");
          }
        }
      });
    },
    editMesero(datos) {
      this.$swal({
        title: "¿Deseas editar este mesero?",
        text: "Los cambios se verán reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Meseros-updateMesero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const meseroName = datos.Nombre || "MESERO";
            this.$pgsHelper.writeLog({
              Evento: "MESERO_EDIT",
              Mensaje: `Mesero editado: ${meseroName}`.trim(),
              reference: { id: datos.Id, tp: "SEC-Mesero", al: meseroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El mesero se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getMeserosAB();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando mesero",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          if (mesero.Deptos) {
            let deptos = Object.entries(mesero.Deptos);
            let textDepto = "";
            deptos.forEach((depto) => {
              let testDepto = this.$pgsHelper.getById(
                this.departamentos,
                "Id",
                depto[0]
              );
              if (testDepto) {
                textDepto = textDepto + testDepto.Nombre + " ";
              }
            });
            mesero.DepartamentoText = textDepto;
          }

          /*let claims = this.$route.params.user.tokenResult.claims;
          
          /*if (claims?.Data?.Only) {
            Object.entries(claims.Data.Only).forEach((item) => {
              if (deptos.includes(item[0])) {
                this.meseros.push(mesero);
              }
            });
          } else {
            this.meseros.push(mesero);
          }*/
        });
      }
    },
  },
  computed: {},
  watch: {},
  mounted() { },
  created() {
    this.getDepartamentosAB();
    this.getMeserosAB();
  },
};
</script>
